// Desktop Sidebar Styles
// Persistent left-rail navigation shown at >=1024px, replacing the mobile
// bottom tab bar (which hides itself at that breakpoint). Mirrors
// SocialFeed/BottomNavigation.styles.ts's visual language (colors, active
// state) but laid out as a vertical rail instead of a horizontal bar.

import styled, { css } from "styled-components";
import { theme } from "../theme";

export const DesktopSidebarContainer = styled.nav<{ $isVisible: boolean }>`
  display: none;

  @media (min-width: calc(${theme.breakpoints.tablet} + 1px)) {
    display: ${({ $isVisible }) => ($isVisible ? "flex" : "none")};
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 88px;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing.md};
    padding: ${theme.spacing.lg} ${theme.spacing.sm};
    background: var(--bg-card);
    backdrop-filter: blur(20px);
    border-right: 1px solid var(--border-light);
    box-shadow: ${theme.shadows.medium};
    z-index: 1000;
    box-sizing: border-box;
  }
`;

export const SidebarItem = styled.button<{
  $isActive: boolean;
  $variant?: "primary" | "secondary";
}>`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  width: 100%;
  background: none;
  border: none;
  color: ${({ $isActive }) => ($isActive ? theme.colors.primary : "var(--text-secondary)")};
  font-size: 0.7rem;
  font-weight: ${({ $isActive }) => ($isActive ? "600" : "400")};
  cursor: pointer;
  transition: all 0.2s ease;
  padding: ${theme.spacing.sm} 4px;
  border-radius: ${theme.borderRadius.md};
  position: relative;

  &:hover {
    color: ${theme.colors.primary};
    background: var(--bg-secondary);
  }

  &:active {
    transform: scale(0.95);
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      background: var(--bg-secondary);
      &::before {
        content: "";
        position: absolute;
        left: -${theme.spacing.sm};
        top: 50%;
        transform: translateY(-50%);
        width: 3px;
        height: 60%;
        background: ${theme.colors.primary};
        border-radius: 0 4px 4px 0;
      }
    `}
`;

export const SidebarIcon = styled.span<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: inherit;

  svg {
    width: 100%;
    height: 100%;
  }
`;

export const SidebarLabel = styled.span`
  font-size: 0.65rem;
  line-height: 1;
  text-align: center;
`;

export const SidebarSpecialButton = styled.div<{ $isActive: boolean }>`
  position: relative;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: ${({ $isActive }) =>
    $isActive ? theme.colors.gradients.primary : theme.colors.gradients.warm};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: ${theme.shadows.medium};
  transition: all 0.3s ease;

  svg {
    width: 20px;
    height: 20px;
    color: white;
  }
`;
